import { render, staticRenderFns } from "./ShowTable.vue?vue&type=template&id=56542996&scoped=true&"
import script from "./ShowTable.vue?vue&type=script&lang=js&"
export * from "./ShowTable.vue?vue&type=script&lang=js&"
import style0 from "./ShowTable.vue?vue&type=style&index=0&id=56542996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56542996",
  null
  
)

export default component.exports